export default {"src":"/_next/static/media/disable_filled.431a46f0.svg","height":24,"width":24};